import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  switchViewIcon: {
    cursor: 'pointer',
    padding: '7px',
  },
  switchViewIconRight: {
    cursor: 'pointer',
    paddingLeft: '6px',
    borderLeft: 'solid 1px rgba(44, 45, 62, 0.3)',
    borderRadius: '0px',
  },
  switchViewOutline: {
    display: 'flex',
    alignItems: 'center',
    justifyItems: 'center',
    border: 'solid 1px rgba(44, 45, 62, 0.3)',
    borderRadius: '5px',
    margin: '0 15px 0 15px',
  },
  customTooltip: {
    backgroundColor: '#2C2D3E',
  },
  customArrow: {
    color: '#2C2D3E',
  },
}));
